import SubscriptionPlan from "types/enums/SubscriptionPlan"

export const subscriptionPlanBundlesContractorsUniversity = (plan: SubscriptionPlan | undefined): boolean =>
  plan === SubscriptionPlan.E_PLUS ||
  plan === SubscriptionPlan.NETWORK ||
  plan === SubscriptionPlan.GROW_MARCH_2026 ||
  plan === SubscriptionPlan.START ||
  plan === SubscriptionPlan.BASIC_MAY_2026 ||
  plan === SubscriptionPlan.NETWORK_JULY_2026 ||
  plan === SubscriptionPlan.BASIC_JULY_2026
